import {register} from '../vendor/theme-scripts/theme-sections';
import {tooltipSection} from '../features/tooltip';
import parallaxHero from '../features/parallax-hero';

register('article', [tooltipSection, parallaxHero]);
